/**
 * Language Utilities
 * RTL detection and language cycling for multi-language support
 */

const RTL_LANGUAGES = ['ar', 'ur', 'he', 'fa'] as const

/**
 * Check if a language code is for a right-to-left language
 */
export function isRtlLanguage(lang: string): boolean {
  return RTL_LANGUAGES.includes(lang as typeof RTL_LANGUAGES[number])
}

/**
 * Get the next language in the cycle: en -> ar -> ur -> en
 */
export function getNextLanguage(currentLang: string): string {
  const languages = ['en', 'ar', 'ur']
  const currentIndex = languages.indexOf(currentLang)
  if (currentIndex === -1) return 'en'
  return languages[(currentIndex + 1) % languages.length]
}
